import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueTheMask from 'vue-the-mask'
import rules from '@/rules'

Vue.use(VueTheMask)
Vue.config.productionTip = false

Vue.prototype.$rules = rules

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
